import { render, staticRenderFns } from "./VInputDescription.vue?vue&type=template&id=235e94ac&scoped=true"
import script from "./VInputDescription.vue?vue&type=script&lang=js"
export * from "./VInputDescription.vue?vue&type=script&lang=js"
import style0 from "./VInputDescription.vue?vue&type=style&index=0&id=235e94ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235e94ac",
  null
  
)

export default component.exports